import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMomentJalaali } from '@mui/x-date-pickers/AdapterMomentJalaali';
import PropTypes from 'prop-types';
import { FormHelperText, InputLabel } from '@mui/material';
import { LabelLine } from '../FieldWrapper/components';
import { useStyles } from './style';

const dateFormats = {
  monthShort: 'jMMMM',
};

const DatePickerPod = ({ children, showAsterisk, label, infoText = null, infoType = null }) => {
  const classes = useStyles({ hasLabel: Boolean(label) });
  return (
    <LocalizationProvider
      dateAdapter={AdapterMomentJalaali}
      adapterLocale="fa"
      dateFormats={dateFormats}
    >
      <div className={classes.root}>
        {label && (
          <InputLabel shrink htmlFor="bootstrap-input-date" className={classes.label}>
            <LabelLine
              label={label}
              infoText={infoText}
              infoType={infoType}
              required={showAsterisk}
            />
          </InputLabel>
        )}
        {children}
        {label && <FormHelperText className={classes.helperText} />}
      </div>
    </LocalizationProvider>
  );
};

DatePickerPod.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DatePickerPod;
